import { render, staticRenderFns } from "./DeLeft2RightDragBar.vue?vue&type=template&id=a65a745c&scoped=true&"
import script from "./DeLeft2RightDragBar.vue?vue&type=script&lang=js&"
export * from "./DeLeft2RightDragBar.vue?vue&type=script&lang=js&"
import style0 from "./DeLeft2RightDragBar.vue?vue&type=style&index=0&id=a65a745c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65a745c",
  null
  
)

export default component.exports